import { ApiTriggerType } from "@superblocksteam/shared";
import { Flag } from "store/slices/featureFlags";
import { useListWorkflowsAndScheduledJobsQuery } from "store/slices/reduxApi/workflowsAndScheduledJobs";
import { useFeatureFlag } from "./useFeatureFlag";

/**
 * Hook to determine if workflows feature should be shown based on:
 * 1. Feature flag cloudprem.workflows being enabled
 * 2. Organization having existing workflows (for conditional hiding)
 *
 * @returns {
 *   canCreateWorkflows: boolean - Can create new workflows (feature flag enabled)
 *   hasExistingWorkflows: boolean - Organization has existing workflows
 *   shouldShowWorkflows: boolean - Should show workflows in UI (flag enabled OR has existing workflows)
 * }
 */
export function useWorkflowsEnabled() {
  const workflowsFeatureFlagEnabled = useFeatureFlag(Flag.CLOUDPREM_WORKFLOWS);

  const { data: workflowsAndScheduledJobs = [] } =
    useListWorkflowsAndScheduledJobsQuery(undefined, {
      refetchOnMountOrArgChange: false,
    });

  const hasExistingWorkflows = workflowsAndScheduledJobs.some(
    (api) =>
      api?.triggerType === ApiTriggerType.WORKFLOW ||
      api?.actions?.triggerType === ApiTriggerType.WORKFLOW,
  );

  return {
    canCreateWorkflows: workflowsFeatureFlagEnabled,
    hasExistingWorkflows,
    shouldShowWorkflows: workflowsFeatureFlagEnabled || hasExistingWorkflows,
  };
}
